import {
  emptyAnalysisSection,
  emptyCollectionsSection,
  emptyInstallationsSection,
  emptyKioskSection,
  emptySessionsSection,
  emptySettingsSection,
  emptyTransactionsSection,
  fetchAnalysisFilters,
  fetchCollectionsFilters,
  fetchInstallationsFilters,
  fetchKioskFilters,
  fetchLiveFloorViewerFilters,
  fetchOrganisations,
  fetchSessionsFilters,
  fetchSettingsFilters,
  fetchTransactionsFilters,
  fetchComplianceFilters,
  fetchCustomerFilters,
} from "@actions";
import React from "react";
import { connect } from "react-redux";

import {
  fetchAnalysisOrganisations,
  fetchKioskOrganisations,
} from "@actions/organisationDirectory";
import OrganisationDirectory from "@shared/OrganisationDirectory";

const OrganisationDirectoryMenu = (props) => {
  const { section, marginLeft, onWidthChange } = props;
  const {
    fetchComplianceFilters,
    fetchCustomerFilters,
    fetchInstallationsFilters,
    fetchTransactionsFilters,
    fetchKioskFilters,
    fetchSessionsFilters,
    fetchAnalysisFilters,
    fetchLiveFloorViewerFilters,
    fetchSettingsFilters,
  } = props;
  const {
    complianceFilters,
    customerFilters,
    installationsFilters,
    transactionsFilters,
    kioskFilters,
    sessionsFilters,
    analysisFilters,
    liveFloorViewerFilters,
    settingsFilters,
  } = props;
  const {
    emptyInstallationsSection,
    emptyTransactionsSection,
    emptyKioskSection,
    emptySessionsSection,
    emptyAnalysisSection,
    emptySettingsSection,
  } = props;

  let defaultProps = {
    showOrgTree: true,
    extraFilters: true,
    data: null,
    onChange: null,
    empty: async () => {},
    hideable: false,
    allowAll: true,
    showEmpty: false,
    includeSearchTerms: true,
    switchTenantOnOperatorChange: false,
    marginLeft,
    section,
    fetchOrganisations,
    onWidthChange,
  };

  switch (section) {
    case "GENERAL_INSTALL":
      return (
        <OrganisationDirectory
          {...props}
          {...defaultProps}
          onChange={fetchInstallationsFilters}
          data={installationsFilters}
          empty={emptyInstallationsSection}
          extraFilters={false}
          allowAll={false}
        />
      );

    case "GENERAL_TRANS":
      return (
        <OrganisationDirectory
          {...props}
          {...defaultProps}
          onChange={fetchTransactionsFilters}
          data={transactionsFilters}
          empty={emptyTransactionsSection}
          extraFilters={false}
          allowAll={false}
        />
      );

    case "KIOSK":
      return (
        <OrganisationDirectory
          {...props}
          {...defaultProps}
          onChange={fetchKioskFilters}
          data={kioskFilters}
          empty={emptyKioskSection}
          fetchOrganisations={fetchKioskOrganisations}
        />
      );

    case "GENERAL_SESSIONS":
      return (
        <OrganisationDirectory
          {...props}
          {...defaultProps}
          onChange={fetchSessionsFilters}
          data={sessionsFilters}
          empty={emptySessionsSection}
        />
      );

    case "GENERAL_ANALYSIS":
      return (
        <OrganisationDirectory
          {...props}
          {...defaultProps}
          onChange={fetchAnalysisFilters}
          data={analysisFilters}
          empty={emptyAnalysisSection}
          fetchOrganisations={fetchAnalysisOrganisations}
          includeSearchTerms={false}
        />
      );

    case "GENERAL_COMMS":
      return (
        <OrganisationDirectory
          {...props}
          {...defaultProps}
          onChange={fetchLiveFloorViewerFilters}
          data={liveFloorViewerFilters}
        />
      );

    case "COMPLIANCE":
      return (
        <OrganisationDirectory
          {...props}
          {...defaultProps}
          onChange={fetchComplianceFilters}
          data={complianceFilters}
          empty={emptyAnalysisSection}
          includeSearchTerms={false}
          allowAll={!props.login.complianceAuthorisationUseCompany}
          switchTenantOnOperatorChange
        />
      );

    case "CUSTOMERS":
      return (
        <OrganisationDirectory
          {...props}
          {...defaultProps}
          onChange={fetchCustomerFilters}
          data={customerFilters}
          empty={emptyAnalysisSection}
          includeSearchTerms={false}
          allowAll={!props.login.complianceAuthorisationUseCompany}
        />
      );

    case "GENERAL_SYSADMIN":
      return (
        <OrganisationDirectory
          {...props}
          {...defaultProps}
          onChange={fetchSettingsFilters}
          data={settingsFilters}
          empty={emptySettingsSection}
          allowAll={false}
          showEmpty={true}
          includeSearchTerms={false}
        />
      );

    default:
      return <span />;
  }
};

const mapStateToProps = (state) => {
  return {
    sessionsFilters: state.sessionsFilters,
    login: state.logIn,
    analysisFilters: state.analysisFilters,
    complianceFilters: state.complianceFilters,
    customerFilters: state.customerFilters,
    collectionsFilters: state.collectionsFilters,
    installationsFilters: state.installationsFilters,
    transactionsFilters: state.transactionsFilters,
    liveFloorViewerFilters: state.LiveFloorViewerFilters,
    settingsFilters: state.settingsFilters,
    kioskFilters: state.kioskFilters,
  };
};

export default connect(mapStateToProps, {
  emptyInstallationsSection,
  emptySessionsSection,
  emptySettingsSection,
  emptyTransactionsSection,
  fetchSettingsFilters,
  fetchComplianceFilters,
  fetchCustomerFilters,
  fetchSessionsFilters,
  emptyCollectionsSection,
  emptyAnalysisSection,
  fetchKioskFilters,
  emptyKioskSection,
  fetchCollectionsFilters,
  fetchAnalysisFilters,
  fetchInstallationsFilters,
  fetchTransactionsFilters,
  fetchLiveFloorViewerFilters,
})(OrganisationDirectoryMenu);
